@if (panel.request(); as request) {
    <!-- Fundo escuro sobre o editor e o cabeçalho. A prévia do PDF fica acima dele (classe
         media-focus no edit.page): o que sobra aceso é o painel e a folha. -->
    <div class="media-backdrop" aria-hidden="true"></div>

    <aside class="media-panel" [attr.aria-label]="request.titleKey | translate">
        <div class="media-panel-inner">
            <header class="panel-header">
                <div class="panel-heading">
                    <ra-icon [icon]="request.icon" varColor="currentColor" [size]="16" />
                    <p class="ra-label-s panel-title">{{ request.titleKey | translate }}</p>
                </div>

                <button
                    type="button"
                    class="panel-icon-button"
                    [attr.aria-label]="'common.close' | translate"
                    [raEditTooltip]="{ text: ('common.close' | translate), position: 'bottom' }"
                    (click)="panel.close()">
                    <ra-icon icon="close" varColor="currentColor" [size]="12" />
                </button>
            </header>

            <div class="panel-body">
                <ng-container [ngTemplateOutlet]="request.template" />
            </div>
        </div>
    </aside>
}
